export const KycProofStatus = {
	"NONE": 0,
	"SUBMITTED": 10,
	"SUCCESSFUL": 20,
	"FAILED": 30,
	"PENDING": 40,
	"REJECTED": 50
};